import React, { Component } from 'react';
import Select from 'react-select';
import MediaQuery from 'react-responsive';

class Dropdown extends Component {

    constructor(props) {
        super(props);        
        this.state = {
            value: this.props.value,
            options: this.props.options
        }
        this.handleChange = this.handleChange.bind(this);   
        this.handleChangeNative = this.handleChangeNative.bind(this);        
    }

    handleChange = (selectedOption) => {
        this.setState({ value:  selectedOption});
        if(typeof this.props.onChange !== 'undefined' && this.props.onChange !== ''){
            this.props.onChange(selectedOption.value);
        }
    }

    handleChangeNative = (event) =>{
        this.setState({ value:  event.target.value});
        if(this.props.onChange !== undefined && this.props.onChange !== ''){
            this.props.onChange(event.target.value);
        }
    }

    render() { 
        let val = this.state.value; 
        let valNative = this.state.value.value;
        if(this.state.options.length > 0 && this.state.value.value === undefined){
            for (let i=0; i<this.state.options.length; i++){
                if(this.state.options[i].value === this.state.value){
                    val = this.state.options[i];
                    valNative =this.state.options[i].value
                }
            }
        }
        return ( 
            <div className="customSelect">
                <MediaQuery query="(min-width: 600px)">
                    <Select
                        value={val}
                        onChange={this.handleChange}
                        options = {this.state.options}
                        placeholder={this.props.placeholder}
                        className={this.props.className}
                        name={this.props.name}
                    />
                </MediaQuery>
                <MediaQuery query="(max-width: 599px)">
                    <select onChange={this.handleChangeNative} value={valNative}>
                    {this.state.options.map((item, i) => <option key={i} value={item.value}>{item.label}</option>)}
                    </select>
                </MediaQuery>
                
            </div>       
            
        );
    }

}

export default Dropdown;